<template>
  <v-card flat>
    <v-form
      v-model="ok"
    >
      <v-container py-0>
        <v-layout wrap>
          <v-flex
            xs6
            md4
          >
            <v-text-field
              label="id"
              light
              disabled
              :value="id"
            />
          </v-flex>
          <v-flex
            xs6
            md4
          />
          <v-flex
            xs6
            md4
          >
            <RefuelButton
              v-if="config.useManualSupplyRegistration"
              :id="id"
              :code="code"
              init-list
            />
          </v-flex>
          <v-flex
            xs5
            md4
          >
            <v-text-field
              v-model="code"
              label="顧客番号"
              class="black-disabled"
              disabled
            />
          </v-flex>
          <v-flex
            xs7
            md8
          >
            <v-text-field
              v-model.trim="name"
              class="black-disabled"
              label="名称"
              :disabled="!isManager(user.roleId)"
            />
          </v-flex>
          <v-flex
            xs12
            md12
          >
            <GroupSelect
              v-model.number="area"
              label="エリア"
              :group="group"
              :disable-company="true"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
            md12
          >
            <v-text-field
              v-model.trim="address"
              label="住所"
              class="purple-input"
            />
          </v-flex>
          <v-flex
            xs12
            md12
          >
            <v-text-field
              v-model.trim="tel"
              label="電話番号"
              class="purple-input"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-model.trim="remarks"
              class="purple-input mt-0 pt-1"
              label="備考"
              rows="3"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <DatePicker
            :delivery="deliveryDate"
            @toggleDialog="toggleDatePicker"
            @input="dateData = $event"
            @set-clear-date-dialog="clearDateDialog=true"
          />
          <v-flex
            class="text-xs-right"
            xs12
          >
            <v-btn
              color="success"
              :disabled="!ok || !dirty || loading"
              :loading="loading"
              @click="update"
            >
              更新
            </v-btn>
          </v-flex>
        </v-layout>
        <DialogBox
          v-model="showDatePicker"
          persistent
          max-width="500"
        >
          <DatePickerDialog
            v-if="showDatePicker"
            :date="dateData"
            @toggle-dialog="toggleDatePicker"
            @date-update="setDeliveryDateHandler"
          />
        </DialogBox>
        <ConfirmDialog
          v-model="clearDateDialog"
          :confirm-text="'クリアする'"
          @confirm="clearDeliveryDateHandler"
          @cancel="clearDateDialog = false"
        >
          指定した日付をクリアしますか？<br><br>
          指定日: {{ deliveryDate.ISOdate }}<br>
          指定者: {{ deliveryDate.name }}<br>
          理由: {{ deliveryDate.reason }}
        </ConfirmDialog>
      </v-container>
    </v-form>
  </v-card>
</template>

<script> // need to add datePicker, datePickerDialog in future
import { mapState, mapMutations, mapActions } from 'vuex'
import { isManager } from '@/utils/helpers.js'
import { ConfirmDialog, DialogBox } from '@/components/dialog'
import { DatePicker } from './CustomerTab/index'
import { GroupSelect } from '@/components/input'

const props = ['id', 'name', 'code', 'area', 'address', 'tel', 'remarks', 'deliveryDate']

export default {
  components: {
    DatePicker,
    DatePickerDialog: () => import('./CustomerTab/DatePickerDialog'),
    ConfirmDialog,
    DialogBox,
    GroupSelect,
    RefuelButton: () => import('@/components/input/RefuelButton')
  },
  props: {
    selected: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      // local customer data
      id: null,
      code: '',
      name: '',
      area: 0,
      address: '',
      tel: '',
      remarks: '',
      deliveryDate: {},
      /// ///
      ok: false,
      loading: false,
      showDatePicker: false,
      dateData: '',
      clearDateDialog: false,
      rules: {
        required: value => !!value || '必須項目です。'
      }
    }
  },
  computed: {
    ...mapState('app', ['config', 'user']),
    ...mapState('groups', ['group']),
    dirty () {
      if (!this.selected) return false
      return !props.every(prop => this.selected[prop] === this[prop])
    }
  },
  watch: {
    selected (value) {
      props.forEach(prop => { this[prop] = value[prop] })
    }
  },
  mounted () {
    props.forEach(prop => { this[prop] = this.selected[prop] })
  },
  methods: {
    ...mapMutations('app', ['setGlobalSnackBarText']),
    ...mapActions('customers', ['updateCustomer', 'setDeliveryDate', 'clearDeliveryDate']),
    isManager,
    async update () {
      if (!this.ok) {
        return
      }

      this.loading = true
      try {
        await this.updateCustomer({
          data: {
            name: this.name,
            deliveryGroupId: this.area,
            address: this.address,
            tel: this.tel,
            remarks: this.remarks
          },
          id: this.id
        })

        this.$emit('reset', this.id)
        this.setGlobalSnackBarText(`${this.name}さんの情報を更新しました。`)
      } finally {
        this.loading = false
      }
    },
    async setDeliveryDateHandler (reason) {
      const operation = await this.setDeliveryDate({
        customerId: this.id,
        deliveryDate: this.dateData,
        reason,
        oldDate: this.deliveryDate.ISOdate || null
      })
      this.showDatePicker = false
      this.$emit('reset', this.id)
      this.setGlobalSnackBarText(`${this.name}さんの配送指定日を${operation}しました。`)
    },
    toggleDatePicker () {
      this.showDatePicker = !this.showDatePicker
    },
    clearDeliveryDateHandler () {
      this.clearDeliveryDate({
        customerId: this.id,
        oldDate: this.deliveryDate.ISOdate
      })
      this.$emit('reset', this.id)
      this.setGlobalSnackBarText(`${this.name}さんの配送指定日をクリアしました。`)
      this.clearDateDialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
.black-disabled /deep/input {
  color: inherit;
}
</style>
